import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function EmptySection() {
  const { t } = useTranslation();
  return (
    <S.EmptySectionWrapper>
      <S.EmptyArea>
        <S.SubTitle variant="body3Bold">{t('analyticsGiftSelectionEmptyState')}</S.SubTitle>
      </S.EmptyArea>
    </S.EmptySectionWrapper>
  );
}

export { EmptySection };
